export default {
  telegramNewDialogVisible: false,
  telegramSelectedCountry: { code: null, flag: null, dial_code: null },
  telegramPhoneCodeHash: null,
  telegramClientStatus: null,
  telegramSignInStatus: null,
  telegramStatusMessage: null,

  loadingTelegramCodeRequest: false,
  telegramCodeRequestFailed: false,
  telegramCodeRequestSuccess: false,
  telegramCodeRequestError: null,

  loadingTelegramSignIn: false,
  telegramSignInFailed: false,
  telegramSignInSuccess: false,
  telegramSignInError: null,
};



// WEBPACK FOOTER //
// ./src/store/modules/telegram/state.js